import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { Observable } from "rxjs";
import { globals } from "../../globals";
import { GiFinPropostaModel } from "../../dominio/gi-fin-proposta-model";
import { IGridifyQuery } from "gridify-client";
import { GiFinSimulacaoModel } from "src/app/dominio/gi-fin-simulacao-model";
import { PaginatedModel } from "src/app/dominio/paginated-model";

export interface OportunidadePropostaGetOneResponse {
  result: GiFinPropostaModel;
}

export class GiFinSimulacaoGetManyResponse {
  results: GiFinSimulacaoModel[];
  pagination: PaginatedModel;
}

export class DetalhePropostaResponse {
  result: GiFinPropostaModel;
}

export interface SimulacaoCadastrarMetadata {
  kwpProjeto?: number | null;
  rendaMensal?: number | null;
  mediaContaEnergia?: number | null;
}

export class SimulacaoCadastrarRequest {
  idIntegrador: number;
  idCupom?: string | null;
  valorSolicitado: number | null;
  valorEntrada?: number | null;
  tipoPessoa: number;
  cpfCnpj: string;
  nome?: string | null;
  uf?: string | null;
  dtNascimento?: Date | null;
  celular?: string | null;
  endereco?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  ibge?: string | null;
  cep?: string | null;
  email?: string | null;
  observacao?: string | null;
  valorServico?: number | null;
  metadata: SimulacaoCadastrarMetadata;
}

export interface SimulacaoCadastrarResponse {
  result: GiFinSimulacaoModel;
}

export class SimulacaoVendaCupomRequest {
  idCupom?: string | null;
}

export class SimulacaoVendaCupomResponse {
  result: GiFinSimulacaoModel;
}

@Injectable({
  providedIn: 'root'
})
export class SimulacaoService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {
  }

  buscarGiFinProposta(idProposta: number): Observable<OportunidadePropostaGetOneResponse> {
    return this.http.get<OportunidadePropostaGetOneResponse>(`${globals.apiUrl}/api/v2/financiamento/simulacao/propostas/${idProposta}`);
  }

  buscarDetalheProposta(idOportunidade: number, idProposta: number): Observable<DetalhePropostaResponse> {
    return this.http.get<DetalhePropostaResponse>(`${globals.apiUrl}/api/v2/crm/resources/oportunidades/${idOportunidade}/propostas-financiamento/${idProposta}`);
  }

  buscarFinSimulacoes(queryFilter: IGridifyQuery | null = null): Observable<GiFinSimulacaoGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<GiFinSimulacaoGetManyResponse>(`${globals.apiUrl}/api/v2/financiamentos/simulacoes`, { params });
  }

  cadastrarFinSimulacao(simulacao: SimulacaoCadastrarRequest): Observable<SimulacaoCadastrarResponse> {
    return this.http.post<SimulacaoCadastrarResponse>(`${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos`, simulacao);
  }

  buscarSimulacaoPedido(idCupom: string): Observable<SimulacaoVendaCupomResponse> {
    return this.http.get<SimulacaoVendaCupomResponse>(`${globals.apiUrl}/api/v2/financiamentos/resources/venda-cupons/${idCupom}/simulacao`);
  }
}
